import { v4 as uuid } from 'uuid'

/** Assign stable ids once — never regenerate on re-render. */
export function ensureRuleRowsWithIds(rules) {
  if (!Array.isArray(rules)) return []
  let changed = false
  const next = rules.map((rule) => {
    if (!rule || typeof rule !== 'object') {
      changed = true
      return { id: uuid(), text: '' }
    }
    if (rule.id) return rule
    changed = true
    return { ...rule, id: uuid() }
  })
  return changed ? next : rules
}

export function ensureStepRowsWithIds(steps) {
  if (!Array.isArray(steps)) return []
  let changed = false
  const next = steps.map((step) => {
    if (!step || typeof step !== 'object') {
      changed = true
      return { id: uuid(), title: '', detail: '', done: false }
    }
    if (step.id) return step
    changed = true
    return { ...step, id: uuid() }
  })
  return changed ? next : steps
}

export function createRuleRow(text = '') {
  return { id: uuid(), text: String(text).trim() }
}

/** Merge legacy bold + text split into one editable line (core idea / checklist rows). */
export function flattenRuleBoldText(rule) {
  if (!rule || typeof rule !== 'object') return rule
  if (rule.mantra != null) return rule
  if (rule.bold == null || !String(rule.bold).trim()) return rule
  const merged = `${String(rule.bold)}${rule.text ?? ''}`.trim()
  return { ...rule, text: merged, bold: undefined }
}

export function createStepRow(title = '') {
  return {
    id: uuid(),
    title: String(title).trim(),
    detail: '',
    done: false,
  }
}

export function resolveFocusRowIndex(rows, focus) {
  if (!focus || !Array.isArray(rows)) return -1
  if (focus.rowId) {
    const byId = rows.findIndex((r) => r?.id === focus.rowId)
    if (byId >= 0) return byId
  }
  if (
    typeof focus.rowIndex === 'number' &&
    focus.rowIndex >= 0 &&
    focus.rowIndex < rows.length
  ) {
    return focus.rowIndex
  }
  return -1
}
